import { step01Win } from "./step_01_win";
import { step02Win } from "./step_02_win";
import { step03Lose } from "./step_03_lose";
import type { GambleFlow } from "@slot/game-shell";

/** Win → win → lose. Typical flow for showcasing the gamble loop. */
export const flowTwoWinsThenLose: GambleFlow = [step01Win, step02Win, step03Lose];
